import * as React from 'react'
import classNames from 'classnames'
import { withStyles, WithStyles, InputAdornment } from '@zn-material-ui'
import Store from 'store'

import TextField from '@components/TextField'
import Input from '@components/Input'
import AdornedButton from '@components/AdornedButton'
import checkCodeFormStyles from './styles/CheckCodeFormStyle'
import AreaSelect from '@components/AreaSelect'
import classnames from 'classnames'
import Checkoutagreement from './Checkoutagreement'
import { transform } from '@utils/intl_lang'
interface IProps extends WithStyles<typeof checkCodeFormStyles> {
  cellphoneNumber: string
  mobilePhoneChange: (event: any) => void
  identityCodeChange: (event: any) => void
  identityCode: string
  canGetIdentityCode: boolean
  handleGetIdentityCode: () => void
  cellphoneBlur: (event: any) => void
  handleNext: (area: string, isTrue: boolean) => void
  onAreaChange: (area: string) => void
  needAgreement?: boolean
  handleAgreement?: () => void
  handlePrivateAgree?: () => void
  count: number
  buttonLabel: string
  cellphoneError: boolean
  identityCodeError: boolean
  loading: boolean
  agreeLabel?: string
}

const CheckIdentityCodeForm: React.SFC<IProps> = props => {
  const {
    classes,
    cellphoneNumber,
    mobilePhoneChange,
    identityCode,
    identityCodeChange,
    canGetIdentityCode,
    handleGetIdentityCode,
    cellphoneBlur,
    needAgreement,
    handleAgreement,
    handlePrivateAgree,
    count,
    buttonLabel,
    cellphoneError,
    identityCodeError,
    loading,
    // "注册即代表同意"
    agreeLabel = transform('Login_register_agree'),
  } = props
  const [area, setArea] = React.useState('86')
  const [isTrue, setIsTrue] = React.useState(false)
  const handleNext = () =>
    props.handleNext((area !== '86' && `00${area}`) || '', isTrue)
  const isCustomLogin = Store.get('isCustomLogin')

  const setChecked = (checked: boolean) => {
    setIsTrue(checked)
  }

  const endAdornment = (
    <InputAdornment position="end">
      <div
        className={classNames(
          classes.identityCodeLabel,
          !canGetIdentityCode ? classes.idCodeDisabled : ''
        )}
      >
        <span onClick={handleGetIdentityCode} className="captcha">
          {/* '获取短信验证码' : `${count}s后可重新获取` */}
          {canGetIdentityCode
            ? transform('Login_get_mes_code')
            : transform('Login_get_code_again', { count })}
        </span>
      </div>
    </InputAdornment>
  )
  return (
    <form
      className={classes.formContainer}
      noValidate={true}
      autoComplete="off"
    >
      <div className={classes.accountContainer}>
        <AreaSelect
          onChange={v => {
            setArea(v)
            props.onAreaChange(v)
          }}
        />
        <TextField
          id="standard-name"
          type="number"
          // '手机号格式错误' : '手机号'
          label={
            cellphoneError
              ? transform('Login_wrong_format_number')
              : transform('Login_mobile_number')
          }
          // "请输入您的手机号码"
          placeholder={transform('Login_enter_mobile_number')}
          value={cellphoneNumber}
          onChange={mobilePhoneChange}
          onBlur={cellphoneBlur}
          error={cellphoneError}
          className={classnames(classes.textField, classes.name)}
          InputClass={{ formControl: classes.inputText }}
        />
      </div>
      <Input
        id="adornment-identity-code"
        type="number"
        // "请输入6位短信验证码"
        placeholder={transform('Login_enter_six_code')}
        value={identityCode}
        onChange={identityCodeChange}
        showLabel={identityCodeError}
        // '验证码错误' : '验证码'
        label={
          identityCodeError
            ? transform('Login_code_error')
            : transform('Login_code')
        }
        containerStyle={classes.identityCode}
        endAdornment={endAdornment}
      />

      {needAgreement && (
        <div className={classes.helper}>
          <Checkoutagreement setChecked={setChecked} />
          <div className={classes.agree}>{agreeLabel}</div>
          <div className={classes.znAgreement} onClick={handlePrivateAgree}>
            {/* `《${!isCustomLogin && 'e祺学' || ''}隐私政策》` */}
            {transform('Login_privacy_policy', {
              isCustomLogin: (!isCustomLogin && 'e祺学') || '',
            })}
          </div>
        </div>
      )}

      <div className={classes.nextButtonWrapper}>
        <AdornedButton
          variant="contained"
          color="primary"
          className={classes.nextButton}
          onClick={handleNext}
          loading={loading}
        >
          {buttonLabel}
        </AdornedButton>
      </div>
    </form>
  )
}

export default withStyles(checkCodeFormStyles)(CheckIdentityCodeForm)
